import {
  sdkContactFormFieldsDataEmitter,
  sdkCustomFieldsConfigurationChangedEmitter,
  sdkEventListenersEmitter,
  sdkSetContentFiltersEmitter,
  sdkSetShowCCFieldEmitter,
  sdkSetShowPartnerCompanyFieldEmitter,
  subscribeToSdk,
} from './';
import { SdkEventType, AnswersSdk, ShowPartnerCompanyFieldData, ContentFilters } from './domain';
import { HelpcenterEvent } from './helpcenter-event';

const isSSR = typeof window === 'undefined';

export const injectAnswersSdk = () => {
  const Answers: AnswersSdk = {
    currentPage: '',
    currentLanguage: '',
    onPageLoad: subscribeToSdk(SdkEventType.PAGE_LOAD),
    onContactFormFieldsChanged: subscribeToSdk(
      SdkEventType.CONTACT_FORM_FIELDS_CHANGED,
    ),
    setContactFormData: (data) => {
      sdkContactFormFieldsDataEmitter.publish(data);
    },
    addEventListener: (cb: (event: HelpcenterEvent) => void) => {
      return sdkEventListenersEmitter.addListener(cb);
    },
    setCustomFieldsConfiguration: (data) => {
      sdkCustomFieldsConfigurationChangedEmitter.publish(data);
    },
    setShowCCField: (shouldShow: boolean) => {
      sdkSetShowCCFieldEmitter.publish(shouldShow);
    },
    setShowPartnerCompanyField: (data: ShowPartnerCompanyFieldData) => {
      sdkSetShowPartnerCompanyFieldEmitter.publish(data);
    },
    setContentFilters: (data: ContentFilters) => {
      sdkSetContentFiltersEmitter.publish(data);
    },
  };

  (window as any).Answers = Answers || {};
};

(function () {
  if (!isSSR) {
    injectAnswersSdk();
  }
})();
